const resolveFetch = (implementation) => {
    if (implementation) {
        return implementation;
    }
    if (typeof fetch === "function") {
        return fetch;
    }
    throw new Error("fetch implementation required for uploads");
};
export async function uploadFileWithPresignedUrl(file, instructions, options) {
    console.log("🚀 Starting file upload:", {
        fileName: file.name,
        fileSize: file.size,
        fileType: file.type,
        uploadUrl: instructions.url,
        method: instructions.method,
        headers: instructions.headers,
    });
    const fetchImpl = resolveFetch(options?.fetchImplementation);
    const headers = new Headers(instructions.headers ?? {});
    if (!headers.has("Content-Type") && file.type) {
        headers.set("Content-Type", file.type);
    }
    console.log("📋 Upload headers:", instructions.headers);
    const method = instructions.method?.toUpperCase() ?? "PUT";
    // Use the file directly instead of creating a stream to avoid compatibility issues
    const body = file;
    console.log("🌐 Making upload request:", {
        url: instructions.url,
        method,
        bodyType: "File",
        fileSize: file.size,
        hasSignal: !!options?.signal,
    });
    try {
        console.log("🔍 About to make fetch request with details:", {
            url: instructions.url,
            method,
            headers: instructions.headers,
            bodyType: typeof body,
            bodySize: body instanceof File ? body.size : 'unknown',
            hasSignal: !!options?.signal,
        });
        const response = await fetchImpl(instructions.url, {
            method,
            headers,
            body: body,
            signal: options?.signal,
        });
        console.log("📡 Upload response received:", {
            status: response.status,
            statusText: response.statusText,
            ok: response.ok,
            headers: "Response headers logged separately",
        });
        if (!response.ok) {
            const errorText = await response.text().catch(() => "Could not read error response");
            console.error("❌ Upload failed:", {
                status: response.status,
                statusText: response.statusText,
                errorText,
                url: instructions.url,
            });
            throw new Error(`Upload failed with status ${response.status}: ${errorText}`);
        }
        if (options?.onProgress) {
            options.onProgress(file.size, file.size);
        }
        const etag = response.headers.get("etag");
        console.log("✅ Upload successful:", {
            fileName: file.name,
            etag,
            responseStatus: response.status,
        });
        return {
            response,
            etag,
        };
    }
    catch (error) {
        console.error("💥 Upload error:", {
            fileName: file.name,
            error: error instanceof Error ? error.message : String(error),
            errorType: error instanceof Error ? error.constructor.name : typeof error,
            url: instructions.url,
            method,
        });
        throw error;
    }
}
